// removed by extract-text-webpack-plugin
module.exports = {"HowItWorksPage":"HowItWorksPage__-loca-__pAiLF","TopNavigation":"HowItWorksPage__-loca-__1ZWcK","About":"HowItWorksPage__-loca-__2MQxx","Contact":"HowItWorksPage__-loca-__BimLC","InfoSection":"HowItWorksPage__-loca-__2fIk0","Highlight":"HowItWorksPage__-loca-__245XE"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/HowItWorks/TrdHowItWorks/HowItWorksPage/HowItWorksPage.css
// module id = 248
// module chunks = 0